import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { PaleState, ThunkDispatchFunc } from '@/interfaces';
import displayValues from '@/resources/displayValues.json';
import { actions } from '@/state/filterActions';
import { type CheckboxDispatchProps, CheckboxFilter } from './CheckboxFilter';

type FacilityFilterProps = {
    onFilterChange: () => void;
};

const facilitiesDisplay: Record<string, string> = displayValues.amenities.facilities;

export const FacilityFilter = ({ onFilterChange }: FacilityFilterProps) => {
    const dispatch = useDispatch<ThunkDispatchFunc>();

    const facetList = useSelector((s: PaleState) => s.results.facets.facilities);
    const checkboxValues = useSelector((s: PaleState) => s.filters.facilities);

    const checkBoxClick: CheckboxDispatchProps['checkBoxClick'] = (valueOrMap) => {
        dispatch(actions.filterCheckboxFacility(valueOrMap));
    };

    const hasOptions = useMemo(() => Array.isArray(facetList) && facetList.some((f) => Boolean(facilitiesDisplay[f.value])), [facetList]);

    return hasOptions ? (
        <CheckboxFilter
            id="facilityFilter"
            label="Fasiliteter"
            facetList={facetList}
            displayValues={facilitiesDisplay}
            checkboxValues={checkboxValues}
            checkBoxClick={checkBoxClick}
            fetchResults={onFilterChange}
        />
    ) : null;
};
